import moment from 'moment-timezone'
import React from 'react'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'

import stg_pos_black_sm from '../../../../../assets/images/stg_pos_black_sm.png'
import withFormSettings from '../../../../hoc/withFormSettings'
import ErrorPage from '../../../common/ErrorPage'
import InitialPage from '../../../common/InitialPage'
import LoadingPage from '../../../common/LoadingPage'
import LoginPage from '../../auth/Signin'

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  width: 100%;
  --custom-primary-color: ${props => props.formSettings.textLinkColour};
  --custom-secondary-color: ${props => props.formSettings.headerColour};
`

class InitialForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      countdownCompletes: false,
    }
  }

  onCountdownComplete = () => {
    this.setState({ countdownCompletes: true })
  }

  render() {
    const { formSettings, history } = this.props
    const { countdownCompletes } = this.state
    const {
      activationDate = '',
      expiryDate = '',
      landingPageImage,
      landingPageLogo,
      orgLogo,
      eventLogo,
      status,
      isArchived,
      timezone,
      formError,
      buttonColour,
      buttonTextColour,
      soldOut,
      formType,
      organisation,
      socials,
      eventDetails,
    } = formSettings || {}

    // biome-ignore lint/complexity/useOptionalChain: TODO
    const isFetchingForm = !(formSettings && formSettings.formId)
    const start = moment.tz(activationDate, timezone)
    const end = moment.tz(expiryDate, timezone)
    // Archived forms always land on the closed page, whatever their status or dates.
    const isLogin = status === 'Active' && !isArchived && !isFetchingForm && moment.tz(timezone).isBetween(start, end)
    const expired = !isFetchingForm && moment.tz(timezone).isAfter(end)

    if (formError) {
      return <ErrorPage errorMessage="Oops! Data not found" />
    }

    return (
      <>
        {isFetchingForm ? (
          <LoadingPage label="Fetching Form" />
        ) : (
          <StyledContainer formSettings={formSettings}>
            <div />
            {!isLogin || soldOut ? (
              <InitialPage
                logo={formType === 'event' ? eventLogo : orgLogo || landingPageLogo}
                showTermsAndConditions
                application="desktop"
                customWidth={550}
                termsLogo={stg_pos_black_sm}
                eventStartDate={start.format('YYYY-MM-DD HH:mm:ss')}
                eventEndDate={end.format('YYYY-MM-DD HH:mm:ss')}
                expired={expired}
                status={status}
                timezone={timezone}
                countdownCompleteMessage="Registrations are now open"
                countdownCompletes={countdownCompletes}
                onCountdownComplete={this.onCountdownComplete}
                buttonBGColor={buttonColour}
                buttonTextColor={buttonTextColour}
                soldOut={soldOut}
                formType={formType}
              />
            ) : (
              <LoginPage
                history={history}
                logo={eventLogo}
                backgroundImage={landingPageImage}
                customWidth={400}
                application="desktop"
                loadingLogin={false}
                orgLogo={orgLogo}
                showSignUp
                showTermsAndConditions
                showGuestLogin
                termsLogo={stg_pos_black_sm}
                title="Login/Register"
                organisation={organisation}
                socials={socials}
                eventDetails={eventDetails}
                formSettings={formSettings}
              />
            )}
          </StyledContainer>
        )}
      </>
    )
  }
}

export default withRouter(withFormSettings(InitialForm))
